import { render } from "./DecretPage.vue?vue&type=template&id=4cb7e4a7"
import script from "./DecretPage.vue?vue&type=script&lang=js"
export * from "./DecretPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__